export const COOK = 'cook';
export const CONSUMER = 'consumer';
export const BOTH = 'both';
